export const fold = (input: string) => {
  if (typeof input.normalize === 'function') {
    return input.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  return input;
};
